import React from "react";
import HighlightedContent from "../atoms/HighlightedContent";
const Error = () => {
    return (React.createElement(HighlightedContent, null,
        React.createElement("h4", null, "Fout opgetreden"),
        React.createElement("p", null, "Wij zijn op de hoogte gebracht van de fout. Probeer het later opnieuw.")));
};
export default Error;
